import PropTypes from 'prop-types'
import { UseI18n } from '../../../common/hooks/useI18n'
import { Element } from '../../../common/html/element'
import { ScrollComponent } from '../../../common/scrollComponent'
import { SizeTracker } from '../../../common/SizeTracker'
import styles from './index.module.scss'

export const Panel = ({
  children,
  label,
  labelExtra,
  isI18n,
  style,
  styleContent,
  isRightHeader,
  renderRightHeader,
  isScroll,
  styleLabel,
  styleExtraLabel,
  refContent,
}) => {
  const formatLabel = isI18n ? UseI18n(label) : label
  const formatExtraLabel = isI18n ? UseI18n(labelExtra) : labelExtra

  const renderHeader = () => (
    <Element className={styles.header} style={{ backgroundColor: '#D5D5D5' }}>
      <Element
        elementName="span"
        style={{
          color: '#191D25',
          fontSize: 14,
          fontWeight: 600,
          ...styleLabel,
        }}
      >
        {formatLabel}
        <Element
          elementName="span"
          style={{
            color: '#191D25',
            fontSize: 14,
            fontWeight: 400,
            fontStyle: 'oblique 40deg',
            paddingLeft: '4px',
            ...styleExtraLabel,
          }}
        >
          {formatExtraLabel}
        </Element>
      </Element>

      {isRightHeader && <Element>{renderRightHeader()}</Element>}
    </Element>
  )

  return (
    <Element
      className={styles.container}
      style={{
        borderColor: '#D5D5D5',
        ...style,
      }}
    >
      <SizeTracker renderTopComponent={renderHeader}>
        {(size) => (
          <div
            ref={refContent}
            style={{
              height: `calc(100% - ${size.height}px)`,
            }}
          >
            {isScroll ? (
              <ScrollComponent>
                <div style={styleContent}>{children}</div>
              </ScrollComponent>
            ) : (
              <div className="h100">{children}</div>
            )}
          </div>
        )}
      </SizeTracker>
    </Element>
  )
}

Panel.propTypes = {
  children: PropTypes.node,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  isI18n: PropTypes.bool,
  style: PropTypes.object,
  isRightHeader: PropTypes.bool,
  renderRightHeader: PropTypes.func,
  labelExtra: PropTypes.string,
  isScroll: PropTypes.bool,
  styleContent: PropTypes.object,
}
Panel.defaultProps = {
  isI18n: false,
  isRightHeader: false,
  renderRightHeader: () => {},
  labelExtra: '',
  isScroll: true,
  styleContent: {
    padding: 12,
  },
}
